import { createClient, searchRequestFactory, SearchOperation } from '@infuse/api/common';

const client = createClient('/rest/operator-api/metrics');

export const metricPermissions = {
  GET_ENERGY_CONSUMPTION: 'cpms.energy-consumption-metrics',
  GET_TRANSACTIONS: 'cpms.transaction-metrics'
};

export const energyConsumptionMetrics: SearchOperation<string> = searchRequestFactory<string>(client, {
  pattern: '/energy-consumption',
  permissionId: metricPermissions.GET_ENERGY_CONSUMPTION
});
export const transactionStatsMetrics: SearchOperation<string> = searchRequestFactory<string>(client, {
  pattern: '/transactions',
  permissionId: metricPermissions.GET_TRANSACTIONS
});
